/** @jsxImportSource @emotion/react */
import React, { useEffect } from 'react';
import { t } from 'i18next';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../core/store';
import { Brand } from '../../../../shared/model/brand.model';
import { SelectItem } from '../../../../shared/ModalSelectField';
import { ModalMultiSelectField } from '../../../../shared/ModalMultiSelectField';
import { ProposalsFilters } from '../../model/proposalsQueryParams';
import { fetchProposalsBrands, selectIsFetching, selectProposalsBrands } from '../../store/auditProposalsAgendaSlice';

interface BrandMultiSelectFieldProps {
  filters: ProposalsFilters;
  defaultValue?: Brand[];
  editable?: boolean;
  onUpdate?: (brand: Brand[]) => void;
}

export function BrandMultiSelectField({
  filters,
  defaultValue = [],
  editable = false,
  onUpdate,
}: BrandMultiSelectFieldProps) {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (editable) {
      dispatch(fetchProposalsBrands(filters));
    }
  }, [dispatch, editable, filters]);

  const brandList = useSelector(selectProposalsBrands);
  const isFetching = useSelector(selectIsFetching);

  const toSelectItem = (item: Brand): SelectItem => {
    return {
      code: item.code,
      description: item.description,
      logo: item.logo,
    };
  };

  const toBrand = (item: SelectItem): Brand => {
    return {
      code: item.code,
      description: item.description,
      logo: item.logo || '',
    };
  };

  return (
    <ModalMultiSelectField
      icon='copyright'
      loading={isFetching}
      defaultValue={defaultValue != null ? defaultValue.map(v => toSelectItem(v)) : []}
      list={brandList.map((b): SelectItem => toSelectItem(b) as SelectItem)}
      title={t('assessment.archive.filters.brands') || ''}
      editable={editable}
      onUpdateValue={(selectedBrand: SelectItem[]) => {
        if (onUpdate) {
          onUpdate(selectedBrand.map(i => toBrand(i)));
        }
      }}
    />
  );
}
